import React from 'react'

function Spinner({ size = 8, className = '', center = true }) {
  const dotSize = `h-${size} w-${size}`
  const centerStyles = center
    ? 'min-h-screen flex justify-center items-center space-x-2'
    : 'flex justify-center items-center space-x-1'

  return (
    <div className={`${centerStyles} ${className}`}>
      <span className="sr-only">Loading...</span>
      <div
        className={`${dotSize} bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.3s]`}
      ></div>
      <div
        className={`${dotSize} bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.15s]`}
      ></div>
      <div
        className={`${dotSize} bg-[#2b364b] rounded-full animate-bounce`}
      ></div>
    </div>
  )
}

export default Spinner
